import qs from 'query-string';
import { useLocation } from '@reach/router';

import { useNavigate } from '@lib/routing';

import type { WindowLocation } from '@reach/router';
import type { ParsedQuery } from 'query-string';

export type LocationQuery = {
    query: ParsedQuery<string>;
    state: Record<string, any>;
    setQuery: (query?: Record<string, any>) => void;
};

const getLocationState = (location: WindowLocation<unknown>) =>
    (location.state ?? {}) as Record<string, any>;

const useLocationQuery = (): LocationQuery => {
    const location = useLocation();
    const navigate = useNavigate();

    const initialQuery = qs.parse(location.search);
    const initialState = getLocationState(location);

    const setQuery = (query?: Record<string, any>, replace = true) => {
        if (!query) {
            navigate(location.pathname);
            return;
        }

        let queryToUpdate = { ...query };

        for (const key in queryToUpdate) {
            if (typeof queryToUpdate[key] === 'object' && !Array.isArray(queryToUpdate[key])) {
                queryToUpdate[key] = JSON.stringify(queryToUpdate[key]);
            }
        }

        const result = qs.stringify(queryToUpdate, { skipEmptyString: true });

        const queryString = result
            ? `${location.pathname}?${result}${location.hash}`
            : location.pathname + location.hash;

        navigate(queryString, { replace, state: getLocationState(location) });
    };

    const result = {
        query: initialQuery,
        state: initialState,
        setQuery,
    };

    return result;
};

export { useLocationQuery };
